<template>
    <div class="base-info is--flex justify-content-between mb-2" ref="intro">
        <app-base-color v-model="base.color"
                        @input="calculatePrices">
        </app-base-color>

        <component :is="baseWidthComponent"
                   v-model="base.width"
                   :disabled="'none' === base.color.class || 'cake-topper' === base.color.class"
                   :color="base.color"
                   :grooves="base.grooves"
                   @input="calculatePrices"
                   v-if="'none' !== base.color.class && 'cake-topper' !== base.color.class">
        </component>
        <app-base-cake v-model="base.cake"
                           v-if="'cake-topper' === base.color.class">
        </app-base-cake>
        <app-base-grooves v-model="base.grooves"
                          :disabled="'none' === base.color.class || 'cake-topper' === base.color.class">
        </app-base-grooves>

    </div>

</template>

<script>
    import EventBus from '../event-bus';
    import AppBaseColor from  './Base/Color';
    import AppBaseWidthDesktop from  './Base/Desktop/Width';
    import AppBaseWidthMobile from  './Base/Mobile/Width';
    import AppBaseGrooves from  './Base/Grooves';
    import AppBaseCake from  './Base/Cake';

    export default {
        props: {
            viewport: Object,
            base: Object,
            plexipeople: Array
        },

        computed: {
            baseWidthComponent() {
                if (this.viewport.isMobile) {
                    return 'app-base-width-mobile';
                }

                return 'app-base-width-desktop';
            },
        },

        methods: {
            calculatePrices() {
                // console.log('Base.vue->calculatePrices');
                EventBus.$emit('calculatePrices');
            },

            registerIntroJsStep(config) {
                if (0 === this.plexipeople.length || 'navigation' !== config.view) {
                    return;
                }

                config.instance.push({
                    element: this.$refs['intro'],
                    intro: 'Wähle nun den passenden Motivsockel zu Deiner Acrylfigur aus. <span>2 Nuten</span> werden <span>nur</span> bei einem <span>mehrteiligen</span> Plexipeople mit <span>mindestens 2 Acrylfiguren</span> benötigt.',
                    step: 20,
                });
            },
        },

        created() {
            EventBus.$on('collectIntroJsSteps', this.registerIntroJsStep);
        },

        beforeDestroy() {
            EventBus.$off('collectIntroJsSteps', this.registerIntroJsStep);
        },

        components: {
            AppBaseColor,
            AppBaseWidthDesktop,
            AppBaseWidthMobile,
            AppBaseGrooves,
            AppBaseCake,
        }
    };
</script>

<style lang="scss">
    @import "../assets/scss/components/base";
</style>



// WEBPACK FOOTER //
// src/components/Base.vue